// extracted by mini-css-extract-plugin
export default {"currency_display":"CurrencyDisplay_currency_display__txdly","dollar_sign":"CurrencyDisplay_dollar_sign__HbCoi","dollar_amount":"CurrencyDisplay_dollar_amount__AgYuS"};